<template>
    <a-date-picker
        v-if="!isMonth"
        v-model="changeValue"
        style="width: 100%"
        :valueFormat="parameters.format"
        :format="parameters.format"
        :clearable="parameters.clearable"
        :placeholder="parameters.placeholder"
        :showTime="isShowTime"
    >
    </a-date-picker>
    <a-month-picker
        v-else
        style="width: 100%"
        v-model="changeValue"
        :valueFormat="parameters.format"
        :format="parameters.format"
        :clearable="parameters.clearable"
        :placeholder="parameters.placeholder">
    </a-month-picker>
</template>

<script>
import { DataEntryMixin } from './mixins';

export default {
    name: 'SdDate',
    mixins: [DataEntryMixin],
    computed: {
        // 是否可编辑
        isModify({ $props }){
            return Boolean($props.field.isModify);
        },
        // 是否是月份
        isMonth() {
            return this.parameters.format === 'YYYY-MM';
        },
        // 是否显示时间
        isShowTime() {
            return this.parameters.format === 'YYYY-MM-DD HH:mm:ss';
        }
    }
};
</script>

<style scoped lang="less"></style>
